import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CadastrarTurmasComponent } from './cadastrar-turmas/cadastrar-turmas.component';
import { TurmasComponent } from './turmas.component';


const routes: Routes = [
  { path: 'turmas/cadastrar', component: CadastrarTurmasComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TURMAS} },
  { path: 'turmas', component: TurmasComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TURMAS} },
  { path: ':area/turmas', component: TurmasComponent, canActivate: [AuthGuard] ,resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TURMAS} },
  { path: ':area/turmas/cadastrar', component: CadastrarTurmasComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TURMAS} },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TurmasRoutingModule { }
